module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "ui menu"
  }, [_vm._h('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/",
      "active-class": "active",
      "exact": ""
    }
  }, ["Home"]), " ", _vm._h('div', {
    staticClass: "right menu"
  }, [_vm._h('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/profile",
      "active-class": "active"
    }
  }, ["Profile"]), " ", (_vm.currentUser) ? _vm._h('div', {
    staticClass: "link item",
    on: {
      "click": _vm.signOut
    }
  }, ["Sign Out"]) : _vm._h('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/signin",
      "active-class": "active"
    }
  }, ["Sign In"]), " "])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b242fe7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopMenu.vue
// module id = 236
// module chunks = 2